import { BRIEF_LIST_QUERY_KEY } from "@entities/brief/lib/constants";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IBriefOperationsUpdateRequest } from "@shared/lib/types/brief";
import { BriefService } from "../services/brief.service";

export function useUpdateBriefOperations() {
  const {
    mutate: updateBriefOperations,
    isLoading: isUpdatingOperations,
    isSuccess: isUpdatedOperations,
    error: updateOperationsError,
  } = useMutation({
    mutationFn: ({
      updatedBriefOperations,
    }: {
      updatedBriefOperations: Partial<IBriefOperationsUpdateRequest>;
    }) =>
      BriefService.updateBriefOperations(updatedBriefOperations).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      ),
    options: {},
    onSuccess: (c, _, data) => {
      ToastService.success("Brief Updated Successfully");
      c.invalidateQueries({ queryKey: BRIEF_LIST_QUERY_KEY });
      c.invalidateQueries({
        queryKey: [
          ...BRIEF_LIST_QUERY_KEY,
          data.updatedBriefOperations.briefId,
        ],
      });
    },
  });
  return {
    updateBriefOperations,
    isUpdatingOperations,
    isUpdatedOperations,
    updateOperationsError,
  };
}
